import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import NewsUploadPage from './pages/NewsUploadPage';
import ContentDetail from './pages/ContentDetail';
import BrowseContent from './pages/BrowseContent';
import CategoryPage from './pages/CategoryPage';
import Header from './components/Header';
import AdminPanel from './pages/AdminPanel';
import Religious from './pages/Religious';
import Images from './pages/Images';
import Videos from './pages/Videos';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload" element={<NewsUploadPage />} />
        <Route path="/content/:token" element={<ContentDetail />} /> {/* Changed from :id to :token */}
        <Route path="/religious" element={<Religious />} />
        <Route path="/images" element={<Images />} />
        <Route path="/videos" element={<Videos />} />
      </Routes>
    </>
  );
}

export default App;